import React from 'react';
import { useNavigate } from 'react-router-dom';
import './UpgradePrompt.css';

/**
 * Shown in place of locked features — displays the feature name,
 * required plan, and a CTA to the billing/subscription page.
 *
 * Props:
 *   feature      {string} - Human-readable feature name
 *   requiredPlan {string} - Minimum plan tier required (e.g. "GOLD")
 */
const UpgradePrompt = ({ feature, requiredPlan }) => {
  const navigate = useNavigate();

  return (
    <div className="upgrade-prompt" role="region" aria-label="Feature locked">
      <div className="upgrade-prompt__icon" aria-hidden="true">🔒</div>
      <h3 className="upgrade-prompt__title">{feature || 'This feature'} is locked</h3>
      <p className="upgrade-prompt__description">
        Available on the <strong>{requiredPlan || 'higher'}</strong> plan and above.
        Upgrade to unlock this feature.
      </p>
      <button
        className="upgrade-prompt__cta"
        onClick={() => navigate('/company/subscription')}
        aria-label={`Upgrade plan to access ${feature}`}
      >
        Upgrade Plan
      </button>
    </div>
  );
};

export default UpgradePrompt;
